<template>
    <div>
        <el-dialog :title="dialogTitle" :visible.sync="dialog" center width="400px" @close="closeEvent"
            :close-on-click-modal="false" top="50px" custom-class="login-dialog-content">
            <div class="bind-phone-dialog">
                <template v-if="loginMode === 'phone'">
                    <el-form ref="form" :model="form" :rules="rules" class="bind-phone">
                        <el-form-item prop="phone">
                            <el-input v-model.trim="form.phone" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input placeholder="请输入密码" type="password" @keyup.enter.native="handleSubmit"
                                v-model="form.password"> </el-input>
                        </el-form-item>
                    </el-form>
                    <div v-if="isToolMainSite() && showOtherLogin">
                        <div class="dividing-line">
                            <i></i>
                            <span>其他方式登录</span>
                        </div>

                        <div class="login-alt-links">
                            <a href="javascript:;" @click.prevent="weChatLoginClick">微信登录</a>
                            <span class="login-alt-links__sep">|</span>
                            <a href="javascript:;" @click.prevent="switchToChildLogin">子账号登录</a>
                        </div>
                    </div>
                </template>
                <child-account-login
                    v-else
                    ref="childAccountLogin"
                    :ex-data="exData"
                    @back="switchToPhoneLogin"
                    @success="onChildAccountLoginSuccess"
                    @forget="forget"
                />
            </div>
            <div v-if="loginMode === 'phone'" slot="footer" class="dialog-footer text-center">
                <el-button class="width-100 footer-btn" type="primary" @click="handleSubmit">登录</el-button>
                <p class="text-center marginT-10"><a class="fc-blue" href="javascript:;" @click="forget">忘记密码？</a></p>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ChildAccountLogin from './child-account-login.vue'

export default {
    components: {
        ChildAccountLogin,
    },
    props: {
        value: {
            type: Boolean,
            default: true,
        },
        exData: {
            type: [String, Object],
            default: '',
        },
    },
    data() {
        return {
            dialog: !!this.value,
            loginMode: 'phone', // phone | child
            showOtherLogin: true,
            innerdialog: false,
            checked: true,
            form: {
                phone: '',
                password: '',
            },
            rules: {
                phone: [
                    {
                        type: 'string',
                        required: true,
                        message: '请输入手机号码',
                        trigger: 'blur',
                    },
                ],
                password: [
                    {
                        type: 'string',
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur',
                    },
                ],
            },
        }
    },
    computed: {
        dialogTitle() {
            return this.loginMode === 'child' ? '子账号登录' : '登录账号'
        },
    },
    methods: {
        closeEvent() {
            sessionStorage.removeItem('open_id')
            this.loginMode = 'phone'
            if (this.$refs.childAccountLogin) this.$refs.childAccountLogin.reset()
        },
        switchToChildLogin() {
            this.loginMode = 'child'
            this.$nextTick(() => {
                if (this.$refs.childAccountLogin) this.$refs.childAccountLogin.reset()
            })
        },
        switchToPhoneLogin() {
            this.loginMode = 'phone'
        },
        onChildAccountLoginSuccess(payload) {
            this.dialog = false
            this.$emit('success', payload !== undefined ? payload : this.exData)
        },
        async handleSubmit() {
            this.$refs.form.validate(async valid => {
                sessionStorage.removeItem('sign')
                let uploadData = {
                    ...this.form,
                }
                if (sessionStorage.getItem('open_id')) {
                    uploadData.open_id = sessionStorage.getItem('open_id')
                }
                const { code, data, msg } = await this.$fetch('/tool/members/login', uploadData)
                // sessionStorage.removeItem('open_id');
                if (code === 0) {
                    this.$store.commit('login', {
                        payload: data,
                        callback: () => { // 登录处理后的回调
                            this.$store.dispatch('upDateUser')

                            this.$bus.emit('handleLogin')
                            this.$emit('success', this.exData)
                            this.dialog = false
                            // this.$router.go(0) // 会导致 dispatch('upDateUser') 执行失败
                        }
                    })
                } else {
                    if (msg == '账号或密码不正确') {
                        setTimeout(() => {
                            this.forget()
                        }, 1400)
                    }
                }
            })
        },
        async sendCode() {
            if (this.isSend) return
            //手机号正则验证
            var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
            if (!this.form.phone) {
                this.$message.error('请输入手机号码')
                return
            }
            if (!reg.test(this.form.phone)) {
                //手机号不合法
                this.$message.error('您输入的手机号码不合法，请重新输入')
            }
            const { code } = await api.post('kmd/msg', {
                phone: this.form.phone,
            })
            if (code === 1001) {
                this.$message.success('验证码发送成功!')
                this.time = 60
                this.timer()
            }
        },
        timer() {
            if (this.time > 0) {
                this.time--
                this.btnContent = this.time + 's后重新获取'
                this.isSend = true
                window.timer = setTimeout(this.timer, 1000)
            } else if (this.time === 0) {
                this.btnContent = '获取验证码'
                if (window.timer) clearTimeout(window.timer)
                this.isSend = false
            }
        },
        forget() {
            this.$emit('forget')
        },
        weChatLoginClick() {
            this.$emit('wechatlogin')
        },
    },
    mounted() {
        if (this.getQueryVariable('', 'loginPhone')) {
            this.form.phone = this.getQueryVariable('', 'loginPhone')
        }

        if (sessionStorage.getItem('sign')) {
            this.showOtherLogin = false
        }
    },
    watch: {
        dialog(val) {
            if (!val) this.$emit('input', val)
        },
    },
}
</script>
<style lang="scss">
.login-dialog-content {
    .el-dialog__body {
        padding-bottom: 0 !important;
    }
}

.bind-phone-dialog {
    .bind-phone {
        .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #666;

            a {
                color: #2b90ed;
            }
        }

        .rules-phone .el-form-item__content {
            margin-left: 10px !important;
            margin-top: -15px;
        }

        .send {
            .el-input-group__append {
                background-color: #aaa;
                border-color: #aaa;

                .el-button.is-disabled:hover {
                    border-color: transparent;
                    background-color: transparent;
                    color: inherit;
                }
            }
        }

        .el-input-group__append {
            cursor: pointer;
            background-color: #2b90ed;
            border-color: #2b90ed;
            color: #fff;
        }
    }

    div[role='alert'] {
        margin-top: -20px;
        margin-bottom: 20px;
        padding: 5px 10px;
    }
}

.footer-btn {
    margin-top: -30px;
}

.dividing-line {
    position: relative;
    width: 100%;
    height: 22px;
    text-align: center;

    i {
        position: absolute;
        top: 10px;
        left: 50%;
        margin-left: -100px;
        display: inline-block;
        width: 200px;
        height: 1px;
        background-color: #888;
    }

    span {
        position: absolute;
        left: 50%;
        margin-left: -48px;
        display: inline-block;
        padding: 0 6px;
        background-color: #fff;
    }
}

.img-content {
    display: flex;
    justify-content: center;
    align-items: center;

    .img-item {
        width: 36px;
        height: 36px;
        margin: 0 8px;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
        }
    }
}

.login-alt-links {
    margin-top: 12px;
    margin-bottom: 4px;
    text-align: center;
    font-size: 13px;
    line-height: 1.5;
    color: #999;

    a {
        color: #999;
        cursor: pointer;
        text-decoration: none;

        &:hover {
            color: #666;
        }
    }

    .login-alt-links__sep {
        margin: 0 10px;
        color: #ccc;
        user-select: none;
    }
}</style>
